"use client";

import { MnemonicGridUi } from "./mnemonic-grid-ui";

/** Hidden words are omitted entirely, never blurred or retained in hidden markup. */
export function RecoveryPhraseDisplay({
	words,
	visible,
}: {
	words: readonly string[];
	visible: boolean;
}) {
	return visible ? <MnemonicGridUi columns={3} words={[...words]} /> : null;
}
